import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';

const SIZE = 140;
const STROKE_WIDTH = 10;
const CENTER = SIZE / 2;
const RADIUS = CENTER - STROKE_WIDTH;
const ARC_LENGTH = Math.PI * RADIUS;
const MAX_SCORE = 10;

interface Props {
    score: number;
    passed: boolean;
}

export function AiScoreGauge({ score, passed }: Props) {
    const theme = useTheme();
    const percent = Math.min(1, Math.max(0, score / MAX_SCORE));
    const color = passed ? theme.palette.success.main : theme.palette.error.main;
    const trackColor = theme.palette.divider;

    return (
        <Box sx={{ position: 'relative', width: SIZE, height: SIZE / 2 + STROKE_WIDTH / 2 }}>
            <svg width={SIZE} height={SIZE / 2 + STROKE_WIDTH / 2} viewBox={`0 0 ${SIZE} ${SIZE / 2 + STROKE_WIDTH / 2}`}>
                <path
                    d={`M ${STROKE_WIDTH / 2} ${CENTER} A ${RADIUS} ${RADIUS} 0 0 1 ${SIZE - STROKE_WIDTH / 2} ${CENTER}`}
                    fill="none"
                    stroke={trackColor}
                    strokeWidth={STROKE_WIDTH}
                    strokeLinecap="round"
                />
                <path
                    d={`M ${STROKE_WIDTH / 2} ${CENTER} A ${RADIUS} ${RADIUS} 0 0 1 ${SIZE - STROKE_WIDTH / 2} ${CENTER}`}
                    fill="none"
                    stroke={color}
                    strokeWidth={STROKE_WIDTH}
                    strokeLinecap="round"
                    strokeDasharray={`${ARC_LENGTH} ${ARC_LENGTH}`}
                    strokeDashoffset={ARC_LENGTH * (1 - percent)}
                />
            </svg>
            <Box sx={{ position: 'absolute', top: '55%', left: 0, right: 0, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 0.5 }}>
                <Typography variant="h4" fontWeight={700} sx={{ color, lineHeight: 1 }}>
                    {score.toFixed(1)}
                </Typography>
                <Box sx={{ width: 44, height: 4, borderRadius: 2, bgcolor: color }} />
            </Box>
        </Box>
    );
}
